import { Link } from "@tanstack/react-router";
import googlePartnerLogo from "@/assets/google-partner-logo-transparent.png";
import metaLogo from "@/assets/meta-logo.webp";

export function CredentialStrip() {
  return (
    <section className="credential-strip" aria-label="Platform credentials">
      <div className="wrap">
        <div className="credential-strip-row">
          <div className="credential-strip-marks">
            <img src={googlePartnerLogo} alt="Google Partner" width={426} height={295} loading="lazy" decoding="async" />
            <img src={metaLogo} alt="Meta Business Partner" width={256} height={144} loading="lazy" decoding="async" />
          </div>
          <p className="prose-small">Certified Google Partner and Meta Business Partner. Verified by Google and Meta, not self-reported.</p>
          <Link to="/about" className="mono credential-strip-link">Our credentials →</Link>
        </div>
      </div>
    </section>
  );
}